import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "relative h-full bg-white p-3 text-gray-500 rounded-md text-left font-light text-sm" }
const _hoisted_2 = { class: "flex border-b pb-3" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "inline text-gray-900 font-bold leading-5 relative -top-0.5" }
const _hoisted_5 = { class: "mt-1" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("td", { class: "text-gray-400" }, "Current Price", -1)
const _hoisted_7 = { class: "text-gray-600" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-300" }, "(", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-300 -ml-1" }, ")", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("td", { class: "text-gray-400 pr-2" }, "Rounds Traded", -1)
const _hoisted_11 = { class: "text-gray-600" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FloatArrow = _resolveComponent("FloatArrow")!
  const _component_ArrowSmallUpIcon = _resolveComponent("ArrowSmallUpIcon")!
  const _component_ArrowSmallDownIcon = _resolveComponent("ArrowSmallDownIcon")!
  const _component_PopoverPanel = _resolveComponent("PopoverPanel")!
  const _component_Float = _resolveComponent("Float")!
  const _component_Popover = _resolveComponent("Popover")!

  return (_openBlock(), _createBlock(_component_Popover, null, {
    default: _withCtx(() => [
      _createVNode(_component_Float, {
        show: _ctx.shouldShow,
        placement: "bottom",
        offset: 15,
        arrow: ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            onMouseenter: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.open && _ctx.open(...args))),
            onMouseleave: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.delayClose && _ctx.delayClose(...args))),
            class: _normalizeClass(_ctx.class)
          }, [
            _renderSlot(_ctx.$slots, "default")
          ], 34),
          _createVNode(_component_PopoverPanel, {
            static: "",
            class: "w-[250px] bg-white border border-gray-200 rounded-md shadow-lg focus:outline-none"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_FloatArrow, { class: "absolute bg-white w-5 h-5 rotate-45 border border-gray-200" }),
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("img", {
                    src: _ctx.imageUrlSmall,
                    class: "inline mr-2 h-9"
                  }, null, 8, _hoisted_3),
                  _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.brand.name) + " " + _toDisplayString(_ctx.caliber.name) + " " + _toDisplayString(_ctx.bulletType.name) + " " + _toDisplayString(_ctx.bulletWeight.id) + " Grain " + _toDisplayString(_ctx.caseMaterial.name), 1)
                ]),
                _createElementVNode("table", _hoisted_5, [
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _hoisted_6,
                      _createElementVNode("td", _hoisted_7, [
                        _createTextVNode(_toDisplayString(_ctx.price) + "¢ ", 1),
                        _hoisted_8,
                        _createElementVNode("span", {
                          style: _normalizeStyle({ color: _ctx.priceDiffColor })
                        }, [
                          _createTextVNode(_toDisplayString(_ctx.priceDiff) + "¢ ", 1),
                          (_ctx.priceDiff > 0)
                            ? (_openBlock(), _createBlock(_component_ArrowSmallUpIcon, {
                                key: 0,
                                class: "inline h-5 text-green-500 -ml-1 -mt-0.5"
                              }))
                            : (_ctx.priceDiff < 0)
                              ? (_openBlock(), _createBlock(_component_ArrowSmallDownIcon, {
                                  key: 1,
                                  class: "inline h-5 text-red-500 -ml-1 -mt-0.5"
                                }))
                              : _createCommentVNode("", true)
                        ], 4),
                        _hoisted_9
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_10,
                      _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.addCommas(_ctx.roundsTradedToday)), 1)
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 3
      }, 8, ["show"])
    ]),
    _: 3
  }))
}